import { Card } from 'antd'
import styled from 'styled-components'

export const StyledCard = styled(Card)`
    margin: 8px 16px !important;
`
export const StyledDivLine = styled.div`
    background-color: #acd458;
    height: 2px;
    width: 185px;
    margin-top: 30px;
    margin-bottom: 30px;
`

export const StyledDivLineGrey = styled.div`
    background-color: #d0cece;
    height: 1px;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 30px;
`
export const StyledCardFullPreview = styled(Card)`
    margin: 8px 16px !important;
    font-family: 'THSarabunNew';
`
